module.exports = __webpack_public_path__ + "static/img/arthroscopy-detail-13.dc63b36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-detail-13.jpg
// module id = /IOR
// module chunks = 51